import React, { useEffect, useCallback } from "react";

const ActivationModal = ({ isOpen, onClose, children }) => {
  const handleKey = useCallback(
    (e) => {
      if (!isOpen) return;
      if (e.key === "Escape") onClose?.();
    },
    [isOpen, onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, handleKey]);

  if (!isOpen) return null;

  return (
    <div
      className="
        fixed inset-0 z-50 flex items-center justify-center px-4
        bg-black/30 dark:bg-black/55
      "
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="
          w-full max-w-[560px] overflow-hidden rounded-xl shadow-2xl
          border border-slate-200 bg-white text-slate-900
          dark:border-white/20 dark:bg-[#333333] dark:text-white
        "
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default ActivationModal;